module.exports = __webpack_public_path__ + "static/media/FolagiAvatar.f633a22d.png";